import { useContext, useState } from 'react';
import { string } from 'prop-types';
import { useLazyQuery } from '@apollo/client';
import { ExperienceContext } from '~/@thd-nucleus/experience-context';
import getPackageQuery from '../queries/package/getPackagesQuery';
import { useQuery } from './useQuery';

const usePackage = ({
  itemId, limit = 1, packageId, storeId, productDomains = ['identifiers'], ssr = true, lazy = false,
}) => {

  const [sId, setStoreId] = useState(storeId);
  const ctx = useContext(ExperienceContext);

  const opts = {
    ssr,
    errorPolicy: 'all',
    variables: {
      itemId,
      packageId,
      limit,
      storeId: sId,
    }
  };

  const Query = getPackageQuery({ productDomains });

  if (lazy) {
    return useLazyQuery(Query, opts);
  }
  const resp = useQuery(Query, opts);

  // useEffect(() => {
  //   if (resp.data && !resp.loading && typeof window !== 'undefined') {
  //     if (!sId && ctx.store && ctx.store.storeId) {
  //       setStoreId(ctx.store.storeId);
  //     }
  //   }
  // }, [resp.loading]);

  return resp;
};

usePackage.propTypes = {
  packageId: string.isRequired
};

export default usePackage;
